/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DeviceLaptopIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Device Laptop',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.948 30.684 32 20V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v15L.052 30.684A1.011 1.011 0 0 0 0 31a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1 1.011 1.011 0 0 0-.052-.316ZM12 30l1.333-4h9.334L24 30Zm18-10H6V6h24Z"
    />
  </svg>`;
};
